<div #collapsible class="collapsible" [class.enabled]="enabled" [class.collapsed]="collapsed">
  <div class="content">
    <ng-content></ng-content>
  </div>

  <div class="read-more d-print-none" (click)="showMore()">
    <div button class="collapse">mehr anzeigen</div>
  </div>
  <div class="read-less d-print-none" (click)="showLess()">
    <div button class="collapse">weniger anzeigen</div>
  </div>
</div>
